import { isValidDate } from '@wiztime/core';
import { useEffect } from 'react';
import { useParams } from 'react-router';
import { RootRedirect } from '../../app/RootRedirect';
import { useViewUi } from '../../shell/viewUiStore';
import { DayView } from './DayView';

/** `#/day/:date`; a malformed date falls back to today. */
export function DayRoute() {
  const { date } = useParams();
  const setLastDayDate = useViewUi((state) => state.setLastDayDate);
  // Remember the day while it is shown: the week and month views hand it back to the day view.
  useEffect(() => {
    if (date !== undefined && isValidDate(date)) setLastDayDate(date);
  }, [date, setLastDayDate]);
  if (date === undefined || !isValidDate(date)) return <RootRedirect />;
  return <DayView date={date} />;
}
